// Shared risk-vector / risk-category / compliance-percentage color mapping.
//
// SINGLE SOURCE OF TRUTH for the color of a 0–100 risk/compliance percentage on the
// dashboards and assessment pages. Higher value = higher risk (red), not "more compliant".
// These bands match the Risk Vector / Domain component on the assessment pages
// (RiskScoreCards.js) and the residual risk score gauge — do not fork per dashboard.
//
// Bands:  >75 critical (red)  >55 high (red)  >35 medium (orange)  >15 low (yellow)  >0 very low (green)

// Full "text-… bg-…" class string (badge style).
export const getComplianceColor = (value) => {
  if (value > 75) return 'text-red-700 bg-red-100';
  if (value > 55) return 'text-red-600 bg-red-100';
  if (value > 35) return 'text-orange-600 bg-orange-100';
  if (value > 15) return 'text-yellow-600 bg-yellow-100';
  if (value > 0)  return 'text-green-600 bg-green-100';
  return 'text-gray-600 bg-gray-100';
};

// Bar / fill color only.
export const getComplianceBarColor = (value) => {
  if (value > 75) return 'bg-red-700';
  if (value > 55) return 'bg-red-500';
  if (value > 35) return 'bg-orange-500';
  if (value > 15) return 'bg-yellow-500';
  if (value > 0)  return 'bg-green-500';
  return 'bg-gray-400';
};

// Text color only (no background) — for inline percentage labels.
export const getComplianceTextColor = (value) => getComplianceColor(value).split(' ')[0];

// Speedometer (risk-score gauge) segments — same bands/colors as the bars above, so a given
// score reads the same on the gauge as in the Risk Vector / Domain lists (e.g. 20% = yellow).
// Hexes mirror Tailwind green-500 / yellow-500 / orange-500 / red-500 / red-700.
export const RISK_GAUGE_SEGMENT_STOPS = [0, 15, 35, 55, 75, 100];
export const RISK_GAUGE_SEGMENT_COLORS = ['#22c55e', '#eab308', '#f97316', '#ef4444', '#b91c1c'];
